import React from 'react';
import ProjectHeaderView from '../view-project-header';
const ProjectHeaderContainer = () => {
  return /*#__PURE__*/React.createElement(ProjectHeaderView, null);
};
export default ProjectHeaderContainer;